import useSWRMutation from 'swr/mutation';
import fetcher from './fetcher';

const useSignDocument = (documentId, options) => useSWRMutation(
  { url: `/documents/${documentId}/sign` },
  fetcher,
  { ...options },
);

export default useSignDocument;
